<template>
  <div
    :class="{
      'expansion-panel': true,
      'is-stand-alone': isStandAlone,
    }"
  >
    <v-expansion-panel>
      <v-expansion-panel-header>
        <template v-slot:default="{ open }">
          <v-row align="center" no-gutters>
            <v-col cols="12" md="8">
              <p
                :class="[{ 'font-weight-medium': isStandAlone }, 'text-body-1']"
              >
                {{ course.name }}
              </p>
            </v-col>
            <v-col class="d-flex justify-md-end mt-5 mt-md-0" cols="12" md="3">
              <mark-as-evaluated
                v-if="isStandAlone"
                :uuid="course.uuid"
                @get-courses="$emit('get-courses')"
              />
            </v-col>
            <v-col
              class="d-md-flex d-none justify-end align-center"
              cols="12"
              lg="1"
              md="1"
            >
              <p
                class="primary--text text-body-1"
                v-text="open ? 'Collapse' : 'Expand'"
              />
            </v-col>
          </v-row>
        </template>
      </v-expansion-panel-header>
      <v-divider v-if="!isStandAlone" />
      <v-expansion-panel-content class="mt-2">
        <base-data-table
          :class="[{ 'qualification-course-table': !isStandAlone }, 'mb-2']"
          :headers="headers"
          :items="course.assignments"
        >
          <template v-slot:[`item.title`]="{ item }">
            <p>
              {{ item.title | formatAssignmentTitle(item.short_title) }}
            </p>
          </template>
          <template v-slot:[`item.evaluation_status`]="{ item }">
            <evaluation-status-display :status="item.evaluation_status" />
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-btn
              color="primary"
              small
              text
              :to="{
                name: 'ViewSubmission',
                params: {
                  submissionId: getSubmissionId(item),
                },
              }"
            >
              View Submission
            </v-btn>
          </template>
        </base-data-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import EvaluationStatusDisplay from '@/components/EvaluationStatusDisplay'
import MarkAsEvaluated from './MarkAsEvaluated'

import { EVALUATION_STATUS } from '@/utils/constants'
import filters from '@/utils/mixins/filters'

export default {
  name: 'CoursePanel',

  components: {
    EvaluationStatusDisplay,
    MarkAsEvaluated,
  },

  mixins: [filters],

  props: {
    course: {
      type: Object,
      required: true,
    },
    isStandAlone: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    headers: [
      {
        text: 'Name',
        sortable: false,
        value: 'title',
      },
      {
        text: 'Status',
        sortable: false,
        value: 'evaluation_status',
      },
      {
        text: '',
        sortable: false,
        value: 'action',
        align: 'end',
      },
    ],
  }),

  methods: {
    getSubmissionId({
      evaluation_status,
      latest_submission,
      evaluated_submission,
    }) {
      if (
        evaluation_status === EVALUATION_STATUS.UNDER_EVALUATION ||
        evaluation_status === EVALUATION_STATUS.SKIPPED
      )
        return latest_submission
      return evaluated_submission
    },
  },
}
</script>

<style lang="scss" scoped>
.expansion-panel {
  .v-expansion-panel {
    background-color: #fff;

    /**
     * If this class is not provided due to propagation stopping,
     * there is a weird opacity ripple effect
     */
    .v-expansion-panel-header::before {
      opacity: 0 !important;
    }

    ::v-deep .v-expansion-panel-header .v-expansion-panel-header__icon .v-icon {
      color: var(--v-primary-base);
    }

    margin: 0.5rem 0;
    &::before {
      box-shadow: none;
    }
    // Every expansion panel other than the first one has a border colour
    &:not(:first-child)::after {
      border-color: #fff;
    }
  }
}

.is-stand-alone {
  .v-expansion-panel {
    background-color: var(--v-secondary-base) !important;
  }
}

.qualification-course-table::v-deep {
  &.theme--light.v-data-table thead {
    background-color: #fff;
  }
}
</style>
